import styled from 'styled-components'

const StTag = styled.div`
  top: -2em;
  left: 0;
  right: 0;
  text-align: center;
`

export { StTag }
